import {
  useAddAccountRoles,
  useUpdateAccountRoleAssignment,
} from "apollo/hooks/mutations";
import { ACCOUNT_ROLE_CLINICAL_DOCUMENTATION } from "core/consts";
import { RecareFileType } from "core/types";
import { useCallback } from "react";

export function useClinicalDocumentationAssignmentMutation() {
  const [addAccountRoles] = useAddAccountRoles();
  const [updateAccountRoleAssignment, mutationProgress] =
    useUpdateAccountRoleAssignment();

  const updateClinicalDocumentationAssignment = useCallback(
    async ({
      accountId,
      careseekerId,
      fileTypes,
      shouldAddRoleFirst,
    }: {
      accountId: number;
      careseekerId: number;
      fileTypes: RecareFileType[];
      shouldAddRoleFirst?: boolean;
    }) => {
      if (shouldAddRoleFirst) {
        await addAccountRoles([
          {
            account_id: accountId,
            careseeker_id: careseekerId,
            role_value: ACCOUNT_ROLE_CLINICAL_DOCUMENTATION,
          },
        ]);
      }

      await updateAccountRoleAssignment(
        {
          file_types: fileTypes,
          role_value: ACCOUNT_ROLE_CLINICAL_DOCUMENTATION,
        },
        {
          account_id: accountId,
          careseeker_id: careseekerId,
        },
      );
    },
    [addAccountRoles, updateAccountRoleAssignment],
  );

  return [updateClinicalDocumentationAssignment, mutationProgress] as const;
}
